import React from "react";
import PageHero from "../components/PageHero";
import BookingForm from "../sections/BookingForm";

export default function Booking() {
  return (
    <>
      <PageHero
        title="Book Your Stay"
        subtitle="Reservations"
        description="Ready to experience Skardu from our panoramic nest? Send us a booking inquiry and we'll confirm within 24 hours."
        image="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1600&q=80"
      />
      <BookingForm />
    </>
  );
}